import React, { useEffect } from 'react';
import { TUTORIAL_ORDER_CARD_INITIAL } from '../../TutorialsContainer';
import TutorialManager, { Step } from '../../TutorialManager';
import {
  DeliveryMenuNavigationItem,
  useDeliveryNavigationActions,
} from '@src/pages/Deliveries/context/delivery-navigation';
import { useOrdersState } from '@src/pages/Deliveries/context/orders';
import utilStorage from '@src/shared/services/util-storage';
import OrderCardInitialTutorialStep1Image from '@assets/ordercard-initial-tutorial-step1-image.png'
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetButton from '@src/shared/components/JetButton';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';
import useGetFeedback from '@src/shared/hooks/use-getfeedback';
import { useTutorialState } from '@src/shared/context/tutorial';
let timer : any
const OrderCardInitialTutorial = () => {
  const { setActiveMenu } = useDeliveryNavigationActions();
  const { ordersById } = useOrdersState();
  const classes = useStyles();
  const {isMobileDevice, isTablet} = useDeviceDetect()
  const isMobileView = isMobileDevice && !isTablet
  const { t, i18n } = useTranslation();
  const { triggerFeedbackCampaign } = useGetFeedback()
  const { activeTutorial } = useTutorialState() 

  const run_MCP_996_feedback_campaign = () => {
    const langExists = ['en','de'].includes(i18n.language)
    if(langExists) {
      triggerFeedbackCampaign('MCP-996',['en','de'], i18n.language)
    }
  }

  const renderStep1 = (closeTutorial: () => void) => {
    return (
      <div>
        <img className={classes.tutorialImage} src={OrderCardInitialTutorialStep1Image} />
        <Typography variant="body1" className={`body_small_bold ${classes.tutorialTitle}`}>
            {t('ordercard_initial_tutorial.step1_title')}      
        </Typography>
        <Typography variant="caption" className="caption">
        {t('ordercard_initial_tutorial.step1_description')} 
        </Typography>
        <JetButton
            variation='primary'
            className={classes.closeButton} 
            onClick={closeTutorial}
            size='xsmall'>
              {t('ordercard_initial_tutorial.step1_cta')} 
          </JetButton>
      </div>
    );
  };

  const steps: Array<Step> = [
    {
      targetElementSelector: '.details-btn',
      content: ({ closeTutorial }) => renderStep1(closeTutorial),
      position: isMobileView ? 'bottom' : 'right',
    },
  ];

  const onBeforeStartHandler = () => {
    setActiveMenu(DeliveryMenuNavigationItem.Orders)
  }

  const onAfterEndHandler = () => {
    utilStorage.setOrderCardInitialTutorialSeen()
    run_MCP_996_feedback_campaign()
  }

  const showTutorial = () => {
    return !utilStorage.getOrderCardInitialTutorialSeen() && Object.keys(ordersById).length > 0
  }

  useEffect(()=> {
    clearTimeout(timer)
    timer = setTimeout(()=> {
      if((!showTutorial() || utilStorage.getOrderCardInitialTutorialSeen()) && activeTutorial === TUTORIAL_ORDER_CARD_INITIAL) {
        run_MCP_996_feedback_campaign()
      } 
    },1000)
  },[ordersById,activeTutorial])

  return (     
     showTutorial() && <TutorialManager
        onBeforeStart={onBeforeStartHandler}
        onAfterEnd={onAfterEndHandler}
        steps={steps}
        tutorialID={TUTORIAL_ORDER_CARD_INITIAL}
      /> || <></>
  );
};

export default OrderCardInitialTutorial;
